import * as firebase from 'firebase'
import { Store } from 'vuex';
import Vue from "vue"

export default {
  state: {
      materials:
      {bomber:{
        BEAUFORTWings:{name:"Aircraft Wings",evidence:"AE_12:The wingspan of this matches that of the Beaufort Bomber"},
        BEAUFORTBody:{name:"Aircraft Fuselage",evidence:"AE_13:The length of this wreck is similar to the dimensions of the Beaufort."},
        BEAUFORT:{name:"Plane Component"},
        winfFlap:{name:"Plane Component"},
        UnderCarrige:{name:"Aircraft Under Carrige"},
        Engine:{name:"Planes Engine",evidence:"AE_11:This engine looks to match that of the missing plane."},
      },
      enterprise:{
        BOAT:{name:"Ship Timbers",materials:"English White Oak"},
        BOAT_SternWindows:{name:"Stern Window",materials:"English White Oak",evidence:"AE_3:Distinctive Stern Windows matching those of the Enterprise."},
        BOAT_SideWindow:{name:"Ship Window",materials:"English White Oak",evidence:"AE_4:White Oak means this is an English ship."},
        BOAT_TimberE:{name:"Ship Timber",materials:"English White Oak",evidence:"AE_4:White Oak means this is an English ship."},
        BOAT_Ribs:{name:"Ship Ribs",materials:"English White Oak",evidence:"AE_4:White Oak means this is an English ship."},
        BOAT_Boards:{name:"Ship Timber",materials:"Pine"},
        WRECK_Mast:{name:"Ship’s Mast",materials:"American Oak"},
        WRECK_Timber:{name:"Ship Timber",materials:"American Oak"},
        WRECK_Window:{name:"Ship Window",materials:"American Oak"},
        WRECK_Iron:{name:"Ship Fitting",materials:"Iron"},
        WRECK_Box1:{name:"Crate",materials:"Pine"},
        WRECK_Rings:{name:"Iron Rings",materials:"Iron"},
      },
      bermagui:{
        Dingy_1:{name:"Lifeboat",materials:"English Oak"},
        Dingy_2:{name:"Lifeboat",materials:"English Oak"},
        Box:{name:"Fish Market Box",materials:"Pine"},
        WoodenBox:{name:"Wooden Box",materials:"Pine"},
        ShippingCrate:{name:"Shipping Crate",materials:"Teak"},
        ShipHull:{name:"Ship's Hull",materials:"Teak",evidence:"AE_1:The length of this hull matches that of the Bermagui."},
        ShipPart:{name:"Ship Component",materials:"Iron"},
        PortHole:{name:"Porthole",materials:"Iron"},
        ShipLight:{name:"Navigational Light",materials:"Iron"},
        Glass:{name:"Broken Window Glass",materials:"Glass"},
        MetalPlate:{name:"Metal Plate",materials:"Iron"},
        ShipCabin:{name:"Ship's Cabin",materials:"Iron",evidence:"AE_2:The width of this matches with the Bermagui."},
        Bracket:{name:"Bracket",materials:"Iron"},
        Mast:{name:"Mast",materials:"Timber"},
        Funnel:{name:"Ship’s Vent",materials:"Iron"},
        Winch:{name:"Anchor Winch",materials:"Various"},
        Bollard:{name:"Mooring Bit",materials:"Iron"},
        Anchor:{name:"Anchor",materials:"Iron"},
        SteamFunnel:{name:"Steam Funnel",materials:"Iron"},
        Door:{name:"Ship's Door",materials:"Iron"},
        Floor:{name:"Lower Deck",materials:"Timber"},
        Deck:{name:"Deck",materials:"Timber"},
        Roof:{name:"Upper Deck",materials:"Iron" }
      },
      pandemonium:{
        ShipRibs:{name:"Ship's Rib",materials:"English Oak",evidence:"AE_41:Mapping out the ribs of this ship suggests that this wreck is a similar size to the Pandemonium."},
        ShipRib:{name:"Ship's Rib",materials:"English Oak",evidence:"AE_41:Mapping out the ribs of this ship suggests that this wreck is a similar size to the Pandemonium."},
        ShipPart:{name:"Ship Timbers",materials:"English Oak"},
        ShipBoards:{name:"Ship Boards",materials:"Baltic Pine"},
        ShipStern:{name:"Ship Timbers",materials:"English Oak"},
        Plank:{name:"Ship Boards",materials:"Baltic Pine"},
        Mast:{name:"Ship's Mast",materials:"Baltic Oak"},
        Grate:{name:"Deck Hatch",materials:"Timber Iron"},
        ShipProw:{name:"Ship's Prow",materials:"English Oak",evidence:"AE_42:The remains of this matches the ships’ plans you have of the Pandemonium."},
        Windows:{name:"Ship's Stern Windows",materials:"English Oak",evidence:"AE_43:The remains of this matches the ships’ plans you have of the Pandemonium."}
      },
      verdoemd:{
        ShipPart:{name:"Ship Timbers",materials:"Oak"},
        ShipRibs:{name:"Ship’s Rib",materials:"Oak",evidence:"AE_51:Mapping out the ribs of this ship suggests that this wreck is a similar size to the Verdoemd."},
        ShipHull:{name:"Ship Hull",materials:"Oak",evidence:"AE_52:The dimensions of the hull match with those of the Verdoemd."},
        Box:{name:"Empty Crate",materials:"Pine"},
        BOX:{name:"Empty Crate",materials:"Pine"},
        Plank:{name:"Ship’s Plank",materials:"Oak"},
        BOAT:{name:"Ship Timbers",materials:"Oak"},
        ShipWinch:{name:"Ship’s Winch",materials:"Oak and Iron"},
        BrokenBARREL:{name:"Broken Barrel",materials:"Oak and Iron"}
      },
      sub:{
        SubPart:{name:"Submarine Part",Materials:"Steel"},
        TROLLEY:{name:"Shopping Trolley",Materials:"Steel"},
        FRIDGE:{name:"Refrigerator",Materials:"Steel"},
        BIKE:{name:"Bicycle",Materials:"Steel"},
        MOPED:{name:"Moped",Materials:"Various"},
        SubHull:{name:"Submarine Hull",materials:"Steel",evidence:"AE_61:The dimensions of the hull match with those for the M28 Midget Submarine."}
      }
    }
        
      },
  mutations: {
    
    
  },
  actions: {
   
  },
  getters: {
      getMaterial: state => material => {
        console.log("getMaterial",state.materials[material.wreck],material)
        if(state.materials[material.wreck] && state.materials[material.wreck][material.name] ){
          
          return state.materials[material.wreck][material.name]
          //return state.materials[material.wreck][material.name]
        }else{
          return {name:material.name}
        }
      },
  }
}

